<div
  #secondaryHeader
  fxLayout="row"
  class="secondary-header"
  [attr.id]="SECONDARY_HEADER_ID"
  [ngClass]="{ menuOpen: isMenuOpen$ | async, 'with-flyout': !isDesktop && isCompanion && !isSearchOnFocus }"
>
  <div fxLayoutAlign="end center" class="secondary-header__container" [ngClass]="{ 'space-between': !isDesktop }">
    <div
      fxHide.mm-desktop="true"
      class="secondary-header__container__menu"
      [@fadeInOut]="!isDesktop && isSearchOnFocus"
    >
      <button
        fxLayout="column"
        fxLayoutAlign="center center"
        [mmTestTarget]="'navigation-open-button'"
        class="open-btn"
        *ngIf="!(isMenuOpen$ | async) && !isAccountSubsidiary"
        [ngClass]="{ 'menu-bar-enabled': isNavigationuBarEnabledV2 }"
        (click)="isSidenavMenuVisible ? showSidenavMenu() : showMobileMenu(menuRef)"
        type="button"
      >
        <svg
          class="text-secondary-main"
          width="24px"
          height="24px"
          fill="#0064fe"
          viewBox="0 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M31.9997,25 C31.9997,25.552 31.5527,26 30.9997,26 L0.9997,26 C0.4467,26 -0.0003,25.552 -0.0003,25
          C-0.0003,24.448 0.4467,24 0.9997,24 L30.9997,24 C31.5527,24 31.9997,24.448 31.9997,25 Z M31.9997,
          16 C31.9997,16.552 31.5527,17 30.9997,17 L0.9997,17 C0.4467,17 -0.0003,16.552 -0.0003,
          16 C-0.0003,15.448 0.4467,15 0.9997,15 L30.9997,15 C31.5527,15 31.9997,15.448 31.9997,
          16 Z M30.9997,8 L0.9997,8 C0.4467,8 -0.0003,7.552 -0.0003,7 C-0.0003,6.448 0.4467,
          6 0.9997,6 L30.9997,6 C31.5527,6 31.9997,6.448 31.9997,7 C31.9997,7.552 31.5527,
          8 30.9997,8 Z"
          ></path>
        </svg>
        <span>{{ 'HEADER.ALL_PAGES.HEADER.MENU' | translate }}</span>
      </button>

      <button
        fxLayout="column"
        fxLayoutAlign="center center"
        [mmTestTarget]="'navigation-close-button'"
        *ngIf="isMenuOpen$ | async"
        class="close-btn"
        (click)="hideMobileMenu()"
        type="button"
      >
        <mm-icon name="close"></mm-icon>
        <span>{{ 'HEADER.ALL_PAGES.HEADER.MENU' | translate }}</span>
      </button>
    </div>

    <app-generic-header-search
      [mmTestId]="'BUYER_PAGES.SEARCH'"
      class="secondary-header__container__search-box"
      [isMobile]="!isDesktop"
      [@grow]="!isDesktop && isSearchOnFocus"
      *ngIf="!(isAccountSubsidiary$ | async)"
    >
    </app-generic-header-search>

    <app-region-selector
      fxHide
      fxHide.mm-desktop="false"
      *ngIf="regionSelector$ | async"
      [isNavigationuBarEnabledV2]="isNavigationuBarEnabledV2"
    ></app-region-selector>

    <app-price-switch fxHide fxHide.mm-desktop="false" [inputId]="'price-switch-mobile-input'">
    </app-price-switch>

    <ng-container *ngIf="!isNavigationuBarEnabledV2 || isAccountSubsidiary">
      <app-header-buy-again fxHide fxHide.mm-desktop="false" *ngIf="!isAccountSubsidiary" [user]="user">
      </app-header-buy-again>

      <app-header-your-assortment *ngIf="isAccountSubsidiary && (isShoppingListEnabled | async)">
      </app-header-your-assortment>

      <span class="divider" fxHide fxHide.mm-desktop="false"></span>

      <div
        fxLayoutAlign="center center"
        class="secondary-header__container__cart"
        [@fadeInOut]="!isDesktop && isSearchOnFocus"
      >
        <a
          cartLink
          (mouseenter)="onMouseHover($event)"
          (mouseleave)="onMouseLeave($event)"
          (click)="trackCartLogoClick()"
          [mmTestTarget]="'cart-link'"
        >
          <app-svg-basket-passive class="icon basket__icon"></app-svg-basket-passive>
          <ng-container *ngIf="totalCartQuantity$ | async as totalCartQuantity">
            <span fxLayoutAlign="center center" test-target="cart-link-quantity">
              {{ totalCartQuantity }}
            </span>
          </ng-container>
        </a>
        <app-mini-shopping-cart
          (showMiniCart)="onShowMiniCart($event)"
          (trackGoToCartClick)="onClickGoToCart()"
          [cartData]="shoppingCartData$ | async"
          [showMiniCart$]="showMiniCart$ | async"
        >
        </app-mini-shopping-cart>
      </div>
      <ng-container *ngIf="!isDesktop && isCompanion">
        <button class="secondary-header__container__flyout-btn" (click)="toggleFlyout($event)"
                [@fadeInOut]="!isDesktop && isSearchOnFocus">
          <mm-icon
          name="registration-type-personal"
        ></mm-icon></button>

      </ng-container>
    </ng-container>

    <ng-container *ngIf="isNavigationuBarEnabledV2 && !isAccountSubsidiary">
      <span class="divider-v2" fxHide fxHide.mm-desktop="false"></span>
      <div fxLayout="row" fxLayoutAlign="flex-start center" class="secondary-header__container__menu_bar">
        <ng-container *ngIf="isMultipleShoppingListEnabled | async; else defaultShoppingList">
          <a
            class="secondary-header__container__menu_bar__list"
            fxHide
            fxHide.mm-desktop="false"
            [mmTestTarget]="'navigation-shoppping-list'"
            [href]="multipleShoppingListUrl"
            (click)="onShoppingListClick($event, true)"
          >
            <app-svg-list class="icon"></app-svg-list>
            <p>{{ 'SHOPPING_LIST_NAV_TITLE' | translate }}</p>
          </a>
        </ng-container>
        <ng-template #defaultShoppingList>
          <a
            class="secondary-header__container__menu_bar__list"
            fxHide
            fxHide.mm-desktop="false"
            [mmTestTarget]="'navigation-shoppping-list'"
            [href]="shoppingListUrl"
            (click)="onShoppingListClick($event)"
          >
            <app-svg-list class="icon"></app-svg-list>
            <p>{{ 'SHOPPING_LIST_NAV_TITLE' | translate }}</p>
          </a>
        </ng-template>

        <a
          *ngIf="!showApprovalDashboard && !(isShowingOrdersHistoryLink$ | async)"
          class="secondary-header__container__menu_bar__buyagain"
          fxHide
          fxHide.mm-desktop="false"
          [href]="[buyAgainExternalLink]"
          [mmTestTarget]="'navigation-buy-again'"
          (click)="onBuyAgainLinkClick($event)"
        >
          <app-svg-re-buy class="icon"></app-svg-re-buy>
          <p>{{ 'BUY_AGAIN_NAV_TITLE' | translate }}</p>
        </a>

        <a
        *ngIf="!showApprovalDashboard && (isShowingOrdersHistoryLink$ | async)"
          class="secondary-header__container__menu_bar__buyagain"
          fxHide
          fxHide.mm-desktop="false"
          [href]="[orderHistoryLinkExternal]"
          [mmTestTarget]="'navigation-orders-history'"
          (click)="onOrdersHistoryLinkClick()"
        >
          <app-svg-box class="icon"></app-svg-box>
          <p>{{ 'ORDERS_HISTORY_NAV_TITLE' | translate }}</p>
        </a>
        <a
          *ngIf="showApprovalDashboard && (isApprovalDashboardFFEnabled$ | async)"
          class="secondary-header__container__menu_bar__buyagain"
          fxHide
          fxHide.mm-desktop="false"
          [href]="[approvalDashboardLink]"
          [mmTestTarget]="'navigation-approval-dashboard'"
          (click)="onApprovalDashboardLinkClick()"
        >
          <app-svg-approvals class="icon"></app-svg-approvals>
          <p>{{ 'APPROVALS_NAV_TITLE' | translate }}</p>
        </a>

        <div
          fxLayoutAlign="center center"
          class="secondary-header__container__menu_bar__cart"
          [ngClass]="{ onHover: (showMiniCart$ | async) }"
          [@fadeInOut]="!isDesktop && isSearchOnFocus"
        >
          <a
            cartLink
            (mouseenter)="onMouseHover($event)"
            (mouseleave)="onMouseLeave($event)"
            (click)="trackCartLogoClick()"
            [mmTestTarget]="'cart-link'"
          >
            <app-svg-cart-v2 class="icon" *ngIf="isDesktop"></app-svg-cart-v2>
            <app-svg-basket-passive class="icon" *ngIf="!isDesktop"></app-svg-basket-passive>
            <p fxHide fxHide.mm-desktop="false">{{ 'CART_NAV_TITLE' | translate }}</p>
            <ng-container *ngIf="totalCartQuantity$ | async as totalCartQuantity">
              <span fxLayoutAlign="center center" test-target="cart-link-quantity">
                {{ totalCartQuantity }}
              </span>
            </ng-container>
          </a>
          <app-mini-shopping-cart
            (showMiniCart)="onShowMiniCart($event)"
            (trackGoToCartClick)="onClickGoToCart()"
            [cartData]="shoppingCartData$ | async"
            [showMiniCart$]="showMiniCart$ | async"
            [isNavigationuBarEnabledV2]="isNavigationuBarEnabledV2 && isDesktop"
          >
          </app-mini-shopping-cart>
        </div>
        <ng-container *ngIf="!isDesktop && isCompanion">
          <button class="secondary-header__container__flyout-btn" (click)="toggleFlyout($event)"
                  [@fadeInOut]="!isDesktop && isSearchOnFocus">
            <mm-icon
              name="registration-type-personal"
            ></mm-icon>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<div #menuRef></div>

<div class="overlay" (click)="hideMobileMenu()" [ngClass]="{ 'overlay--active': mobileMenuShown }"></div>
